// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  COMMON_SET_NOTIFICATION,
} from './constants';

export function setNotification(options) {
  return {
    type: COMMON_SET_NOTIFICATION,
    data: {...options}
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_SET_NOTIFICATION:
      return {
        ...state,
        notification: state.notification.withMutations(notification => {
          for (let option in action.data) {
            notification.set(option, action.data[option])
          }
          return notification
        })
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/setNotification.js